const validators = {
    firstName: (firstName) => {
        if (typeof firstName !== 'string' || firstName.trim() === '') {
            return 'firstName';
        }
        return null;
    },

    lastName: (lastName) => {
        if (typeof lastName !== 'string' || lastName.trim() === '') {
            return 'lastName';
        }
        return null;
    },

    firmName: (firmName) => {
        if (typeof firmName !== 'string' || firmName.trim() === '') {
            return 'firmName';
        }
        return null;
    },

    vatNr: (vatNr) => {
        if (typeof vatNr !== 'string' || vatNr.trim() === '') {
            return 'vatNr';
        }
        return null;
    },

    email: (email) => {
        if (typeof email !== 'string' || email.trim() === '') {
            return 'email.required';
        }
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        if (!emailRegex.test(email)) {
            return 'email.invalid';
        }
        return null;
    },

    telNr: (telNr) => {
        if (typeof telNr !== 'string' || telNr.trim() === '') {
            return 'telNr';
        }
        return null;
    },

    addressLine1: (addressLine1) => {
        if (typeof addressLine1 !== 'string' || addressLine1.trim() === '') {
            return 'addressLine1';
        }
        return null;
    },

    city: (city) => {
        if (typeof city !== 'string' || city.trim() === '') {
            return 'city';
        }
        return null;
    },

    county: (county) => {
        if (typeof county !== 'string' || county.trim() === '') {
            return 'county';
        }
        return null;
    },

    zipCode: (zipCode) => {
        if (typeof zipCode !== 'string' || zipCode.trim() === '') {
            return 'zipCode.required';
        }
        const zipCodeRegex = /^\d{6}$/;
        if (!zipCodeRegex.test(zipCode)) {
            return 'zipCode.invalid';
        }
        return null;
    },

    country: (country) => {
        /* Do not validate
        if (typeof country !== 'string' || country.trim() === '') {
            return 'country';
        }
        */
        return null;
    }
};

export function validateUserInfo(userInfo, doNotValidate) {
    const validationResults = {};
    const base = 'validationErrors.userInfo.';

    Object.keys(validators).forEach((key) => {
        if (!doNotValidate[key]) {
            const errorString = validators[key](userInfo[key]);
            if (errorString) {
                validationResults[key] = base + errorString;
            }
        }
    });

    return Object.keys(validationResults).length > 0 ? validationResults : {};
}


export function validateUserInfoItem(id, value) {
    const base = 'validationErrors.userInfo.';
    if (validators[id]) {
        const errorString = validators[id](value);
        if (errorString) {
            return base + errorString;
        }
    }

    return '';
}